import { render, staticRenderFns } from "./AdditionalServicesDialog.vue?vue&type=template&id=7908654c&scoped=true&lang=pug&"
import script from "./AdditionalServicesDialog.vue?vue&type=script&lang=ts&"
export * from "./AdditionalServicesDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AdditionalServicesDialog.vue?vue&type=style&index=0&id=7908654c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7908654c",
  null
  
)

export default component.exports